export const isSSG = (): boolean => {
  return import.meta.env.SSR;
};
